import { render, staticRenderFns } from "./CloseCart.vue?vue&type=template&id=61d513ac&scoped=true&lang=pug&"
import script from "./CloseCart.vue?vue&type=script&lang=js&"
export * from "./CloseCart.vue?vue&type=script&lang=js&"
import style0 from "./CloseCart.vue?vue&type=style&index=0&id=61d513ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d513ac",
  null
  
)

export default component.exports